/* global store */
/* global IS_PREVIEW_PAGE */

import { getElement, isNestedIframe } from 'Renderer/domOperations/iFrameOperations';
import { initialiseArtboard, selectArtboard } from 'Renderer/domOperations/artboardOperations';
import { initialiseComponentTimelines } from 'Renderer/domOperations/animationOperations';
import imagesLoaded from 'imagesloaded';
import { PARENT_FONT_SIZE_PX } from 'SharedConstants/renderer';
import { appendHtmlToElement } from 'Renderer/utils/';
import { selectActiveArtboard, setRootElement } from 'Renderer/actions/artboardActions';
import { maybeStartAd } from 'Renderer/domOperations/adOperations';
import initialiseDocumentEventListeners from 'Tracking/eventListeners/document';
import { setSelctorStyle } from 'Renderer/domOperations/styleOperations';

const floorValue = value => Math.floor(value);
const ceilValue = value => Math.ceil(value);

const getFilteredArtboards = (artboards, filter) => artboards.filter(a => a.name.includes(filter));

const centreSkinArtboards = artboards => getFilteredArtboards(artboards, 'centre-skin');
const leftSkinArtboards = artboards => getFilteredArtboards(artboards, 'left-skin');
const rightSkinArtboards = artboards => getFilteredArtboards(artboards, 'right-skin');
const backgroundSkinArtboards = artboards => getFilteredArtboards(artboards, 'background-skin');
const backgrondSkinTollerance = 100;

const getCentreSkinContainer = () => {
  const { sessionId } = store.getState();
  return getElement(window.top.document, `#ivoCentreSkinContainer-${sessionId}`);
};

const getCentreSkinWrapper = () => {
  const { sessionId } = store.getState();
  return getElement(window.top.document, `#ivoCentreSkinWrapper-${sessionId}`);
};

const getCentreSkinBottomContainer = () => {
  const { sessionId } = store.getState();
  return getElement(window.top.document, `#ivoCentreSkinBottomContainer-${sessionId}`);
};

const getLeftSkinContainer = () => {
  const { sessionId } = store.getState();
  return getElement(window.top.document, `#ivoLeftSkinContainer-${sessionId}`);
};

const getRightSkinContainer = () => {
  const { sessionId } = store.getState();
  return getElement(window.top.document, `#ivoRightSkinContainer-${sessionId}`);
};

const getBackgroundSkinContainer = () => {
  const { sessionId } = store.getState();
  return getElement(window.top.document, `#ivoBackgroundSkinWrapper-${sessionId}`);
};

const getWindowDimensions = () => {
  const rootDocument = window.top.document; // eslint-disable-line no-undef
  const windowWidth = rootDocument.documentElement.clientWidth;
  const windowHeight = rootDocument.documentElement.clientHeight;
  return { width: windowWidth, height: windowHeight };
};

const getAvailableSkinWidth = () => {
  const { rootBodyElement } = store.getState();
  const contentWidth = rootBodyElement ? rootBodyElement.getBoundingClientRect().width : frameElement.parentNode.parentNode.clientWidth;
  const windowWidth = getWindowDimensions().width;
  return ((windowWidth - contentWidth) / 2);
};

export const resizeSkinsCentreContainer = (artboard, eventType) => {
  const { rootBodyElement } = store.getState();

  const centreSkinContainer = IS_PREVIEW_PAGE ? frameElement : getCentreSkinContainer();
  centreSkinContainer.parentNode.style.transition = 'height 1s';

  if (eventType === 'expand-close') {
    centreSkinContainer.parentNode.style.transition = '';
  }

  const adjustablePercentage = centreSkinContainer.getBoundingClientRect().width / artboard.viewport.width;
  const adjustedWidth = `${artboard.viewport.width * adjustablePercentage}px`;
  const adjustedHeight = `${artboard.viewport.height * adjustablePercentage}px`;

  const style = centreSkinContainer.style || {};
  style.width = adjustedWidth;
  style.height = adjustedHeight;
  style['max-width'] = 'none';
  style['max-height'] = 'none';

  centreSkinContainer.parentNode.style.height = adjustedHeight;

  if (!IS_PREVIEW_PAGE) {
    if (rootBodyElement.getAttribute('data-ivo-config') === 'body') {
      const adjustMargin = rootBodyElement.getAttribute('data-ivo-margin') !== 'none';
      rootBodyElement.style.transition = 'margin 1s';
      if (adjustMargin) rootBodyElement.style.marginTop = adjustedHeight;
    }
  }
};

export const resizeSkinsContainer = (callback = () => {}) => {
  const { rootBodyElement, fluidPlus } = store.getState();
  const rootWindow = window.top; // eslint-disable-line no-undef
  const contentWidth = rootBodyElement ? rootBodyElement.getBoundingClientRect().width : frameElement.parentNode.parentNode.clientWidth;
  const windowWidth = rootWindow.innerWidth;
  const skinWidth = (windowWidth - contentWidth) / 2;

  const centreSkinContainer = getCentreSkinContainer();
  const centreSkinWrapper = getCentreSkinWrapper();
  const leftSkinContainer = getLeftSkinContainer();
  const rightSkinContainer = getRightSkinContainer();

  try {
    const embeddedCentre = (centreSkinContainer.getAttribute('data-display') === 'embedded');
    const adjScale = parseFloat(centreSkinContainer.getAttribute('data-adj')) || 1;
    const geomElem = (embeddedCentre || !centreSkinArtboards) ? rootBodyElement : centreSkinWrapper;
    const skinsPosition = geomElem.getBoundingClientRect();
    const leftSkinWidth = fluidPlus ? skinWidth : parseFloat(leftSkinContainer.getAttribute('data-max-width')) * adjScale;
    const rightSkinWidth = fluidPlus ? skinWidth : parseFloat(rightSkinContainer.getAttribute('data-max-width')) * adjScale;
    if (!embeddedCentre) centreSkinContainer.style.width = `${ceilValue(contentWidth)}px`;
    leftSkinContainer.style.left = `${ceilValue(skinsPosition.left - leftSkinWidth)}px`;
    leftSkinContainer.style.width = `${ceilValue(leftSkinWidth)}px`;
    rightSkinContainer.style.left = `${skinsPosition.right}px`;
    rightSkinContainer.style.width = `${ceilValue(rightSkinWidth)}px`;
    if (callback) callback();
  } catch (e) {
    console.log(e);
    console.log('ivo : error resizing skins container');
  }
};

export const moveSkinContainers = () => {
  const { rootBodyElement } = store.getState();
  const skinContiguration = rootBodyElement.getAttribute('data-ivo-config');
  if (skinContiguration === 'mobile-footer') return;
  const skinsWindow = window.top;
  if (!skinsWindow) return;
  const centreSkinContainer = getCentreSkinContainer();
  const leftSkinContainer = getLeftSkinContainer();
  const rightSkinContainer = getRightSkinContainer();
  if (!leftSkinContainer && !rightSkinContainer) {
    const rootWindow = window.top; // eslint-disable-line no-undef
    rootWindow.removeEventListener('scroll', moveSkinContainers);
    return;
  }
  const scrollDelay = parseInt(rootBodyElement.getAttribute('data-ivo-md'), 10) || 0;
  setTimeout(() => {
    const isEmbedded = (skinContiguration === 'embedded');
    const rootBodyElementOffset = parseInt(rootBodyElement.getAttribute('data-ivo-to'), 10) || 0;
    const rootBodyElementTop = (rootBodyElement.getBoundingClientRect().top + rootBodyElementOffset);
    const topPosition = isEmbedded ? rootBodyElementTop : rootBodyElementTop - centreSkinContainer.getBoundingClientRect().height;
    const topLimit = parseInt(rootBodyElement.getAttribute('data-ivo-tl'), 10);
    const bodySkinContainers = [centreSkinContainer, leftSkinContainer, rightSkinContainer];
    const embeddedSkinContainers = [leftSkinContainer, rightSkinContainer];
    const skinContainers = isEmbedded ? embeddedSkinContainers : bodySkinContainers;
    if (topPosition <= topLimit) {
      [...skinContainers].forEach((e) => { if (e) e.style.top = `${topLimit}px`; });
      return;
    }
    if (centreSkinContainer.getAttribute('data-artboard') !== null) {
      [...skinContainers].forEach((e) => { if (e) e.style.top = `${topPosition}px`; });
    } else {
      [...skinContainers].forEach((e) => { if (e) e.style.top = `${rootBodyElementOffset}px`; });
    }
  }, scrollDelay);
};

const initSkinContainer = (container, artboard, width) => {
  const { timelines } = store.getState();
  const skinsDocment = window.top.document;
  const skinWidth = width || artboard.viewport.width;
  container.setAttribute('data-artboard', artboard.name);
  container.setAttribute('data-max-width', artboard.viewport.width);
  container.setAttribute('data-width', skinWidth);
  setRootElement(container);
  selectActiveArtboard(artboard);
  timelines[artboard.key].pause(0);
  container.style.width = `${ceilValue(skinWidth)}px`;
  container.style.height = `${artboard.viewport.height}px`;
  container.innerHTML = artboard.html;
  container.style.backgroundColor = getElement(container, '#i-a-wrapper div').style.backgroundColor;
  setSelctorStyle(container, '#i-a-wrapper div', 'overflow', 'hidden');
  setSelctorStyle(container, '#i-a-wrapper div', 'overflowY', 'hidden');
  appendHtmlToElement(artboard.monotype, skinsDocment.head);
  imagesLoaded(container, { background: '*' }, initialiseArtboard(artboard));
  initialiseDocumentEventListeners(container);
  initialiseComponentTimelines(artboard);
  maybeStartAd(artboard);
};

const initCentreSkinContainer = (container, artboard) => {
  const { timelines } = store.getState();
  const skinsDocment = window.top.document;
  const adjustment = container.getBoundingClientRect().width / artboard.viewport.width;
  container.setAttribute('data-artboard', artboard.name);
  container.setAttribute('data-width', artboard.viewport.width);
  container.setAttribute('data-adj', adjustment);
  setRootElement(container);
  selectActiveArtboard(artboard);
  timelines[artboard.key].pause(0);
  container.innerHTML = artboard.html;
  container.style.backgroundColor = getElement(container, '#i-a-wrapper div').style.backgroundColor;
  setSelctorStyle(container, '#i-a-wrapper div', 'overflow', 'hidden');
  appendHtmlToElement(artboard.monotype, skinsDocment.head);
  imagesLoaded(container, { background: '*' }, initialiseArtboard(artboard));
  initialiseDocumentEventListeners(container);
  maybeStartAd(artboard);
};

export const renderSkins = () => {
  const { artboards, timelines, fluidPlus } = store.getState();
  const skinsDocment = window.top.document;
  const centreSkinContainer = getCentreSkinContainer();
  const centreSkinBottomContainer = getCentreSkinBottomContainer();
  const leftSkinContainer = getLeftSkinContainer();
  const rightSkinContainer = getRightSkinContainer();
  const backgroundSkinContainer = getBackgroundSkinContainer();

  const availableWidth = getAvailableSkinWidth();

  const centreArtboards = centreSkinArtboards(artboards);
  const backgroundArtboard = selectArtboard(backgroundSkinArtboards(artboards), [getWindowDimensions().width + backgrondSkinTollerance, getWindowDimensions().height + backgrondSkinTollerance]);

  let leftSkinArtboard;
  let rightSkinArtboard;

  if (backgroundArtboard) initSkinContainer(backgroundSkinContainer, backgroundArtboard);

  if (centreArtboards.length) {
    const topArtboards = centreSkinArtboards(artboards).filter(a => a.name.includes('-top'));
    const centreArtboard = topArtboards.length ? topArtboards : centreArtboards;
    const centreSkinArtboard = selectArtboard(centreArtboard, [centreSkinContainer.clientWidth, centreSkinContainer.clientHeight]);
    const centreAdjustment = centreSkinContainer.getBoundingClientRect().width / centreSkinArtboard.viewport.width;

    initCentreSkinContainer(centreSkinContainer, centreSkinArtboard);

    if (centreSkinBottomContainer) {
      const bottomArtboards = centreArtboards.filter(a => a.name.includes('-bottom'));
      const bottomArtboard = selectArtboard(bottomArtboards, [centreSkinBottomContainer.clientWidth, centreSkinBottomContainer.clientHeight]);
      initCentreSkinContainer(centreSkinBottomContainer, bottomArtboard);
    }

    const adj = centreSkinContainer.getAttribute('data-adj') || 1;
    leftSkinArtboard = selectArtboard(leftSkinArtboards(artboards), [availableWidth / adj, leftSkinContainer.clientHeight]);
    rightSkinArtboard = selectArtboard(rightSkinArtboards(artboards), [availableWidth / adj, rightSkinContainer.clientHeight]);

    if (leftSkinArtboard) {
      const leftSkinWidth = fluidPlus ? availableWidth : leftSkinArtboard.viewport.width;
      initSkinContainer(leftSkinContainer, leftSkinArtboard, leftSkinWidth);
    }

    if (rightSkinArtboard) {
      const rightSkinWidth = fluidPlus ? availableWidth : rightSkinArtboard.viewport.width;
      initSkinContainer(rightSkinContainer, rightSkinArtboard, rightSkinWidth);
    }

    if (!fluidPlus) {
      const fluidLeftSkinWidth = parseFloat(leftSkinContainer.getAttribute('data-width')) * centreAdjustment;
      const fluidRightSkinWidth = parseFloat(rightSkinContainer.getAttribute('data-width')) * centreAdjustment;
      leftSkinContainer.style.width = `${ceilValue(fluidLeftSkinWidth)}px`;
      rightSkinContainer.style.width = `${ceilValue(fluidRightSkinWidth)}px`;
    }
  } else {
    centreSkinContainer.style.display = 'none';
  }
  moveSkinContainers();
  resizeSkinsContainer(() => {
    setSelctorStyle(leftSkinContainer, '#i-a-wrapper', 'overflow', 'hidden');
    setSelctorStyle(rightSkinContainer, '#i-a-wrapper', 'overflow', 'hidden');

    leftSkinContainer.style.fontSize = `${PARENT_FONT_SIZE_PX * parseFloat(leftSkinContainer.clientWidth / leftSkinArtboard.viewport.width).toFixed(2)}px`;
    rightSkinContainer.style.fontSize = `${PARENT_FONT_SIZE_PX * parseFloat(rightSkinContainer.clientWidth / rightSkinArtboard.viewport.width).toFixed(2)}px`;

    if (centreArtboards.length) {
      const centreSkinArtboard = selectArtboard(centreSkinArtboards(artboards), [centreSkinContainer.clientWidth, centreSkinContainer.clientHeight]);
      centreSkinContainer.style.fontSize = `${PARENT_FONT_SIZE_PX * parseFloat(centreSkinContainer.clientWidth / centreSkinArtboard.viewport.width).toFixed(2)}px`;
    }
  });
};

export const maybeRenderSkins = () => {
  const { artboards, rootBodyElement } = store.getState();
  const centreSkinWrapper = getCentreSkinWrapper();
  const centreSkinContainer = getCentreSkinContainer();
  const centreSkinBottomContainer = getCentreSkinBottomContainer();
  const leftSkinContainer = getLeftSkinContainer();
  const rightSkinContainer = getRightSkinContainer();
  const backgroundSkinContainer = getBackgroundSkinContainer();
  const skinContiguration = rootBodyElement.getAttribute('data-ivo-config');

  if (!leftSkinContainer && !rightSkinContainer) {
    const rootWindow = window.top; // eslint-disable-line no-undef
    rootWindow.removeEventListener('resize', maybeRenderSkins);
    return;
  }

  const centreArtboards = centreSkinArtboards(artboards);

  const dataResizeDelay = rootBodyElement.getAttribute('data-ivo-resize-delay');
  const resizeDelay = (dataResizeDelay === null) ? 1000 : parseInt(dataResizeDelay, 10);

  setTimeout(() => {
    resizeSkinsContainer(() => {
      let centreSkinArtboard = null;

      if (centreArtboards.length) {
        centreSkinArtboard = selectArtboard(centreSkinArtboards(artboards), [centreSkinContainer.clientWidth, centreSkinContainer.clientHeight]);

        if (centreSkinBottomContainer) {
          const topArtboards = centreArtboards.filter(a => a.name.includes('-top'));
          const bottomArtboards = centreArtboards.filter(a => a.name.includes('-bottom'));
          const bottomArtboard = selectArtboard(bottomArtboards, [centreSkinBottomContainer.clientWidth, centreSkinBottomContainer.clientHeight]);
          const centreBottomAdjustablePercentage = centreSkinBottomContainer.getBoundingClientRect().width / bottomArtboard.viewport.width;
          centreSkinBottomContainer.style.height = `${bottomArtboard.viewport.height * centreBottomAdjustablePercentage}px`;
          if (topArtboards) centreSkinArtboard = selectArtboard(topArtboards, [centreSkinContainer.clientWidth, centreSkinContainer.clientHeight]);
        }

        const centreContainer = centreSkinBottomContainer || centreSkinContainer;
        const embeddedCentre = (centreContainer.getAttribute('data-display') === 'embedded');
        const centreAdjustablePercentage = centreSkinContainer.getBoundingClientRect().width / centreSkinArtboard.viewport.width;
        centreSkinContainer.style.height = `${centreSkinArtboard.viewport.height * centreAdjustablePercentage}px`;

        if (!embeddedCentre) {
          const contentWidth = rootBodyElement ? ceilValue(rootBodyElement.getBoundingClientRect().width) : ceilValue(frameElement.parentNode.parentNode.clientWidth);
          const adjustedHeight = ceilValue(centreSkinArtboard.viewport.height * centreAdjustablePercentage);
          centreSkinWrapper.style.width = `${contentWidth}px`;
          centreSkinContainer.style.width = `${contentWidth}px`;
          centreSkinContainer.parentNode.style.height = `${adjustedHeight}px`;
          centreSkinContainer.parentNode.parentNode.style.height = `${adjustedHeight}px`;
          if (skinContiguration === 'body') {
            const adjustMargin = rootBodyElement.getAttribute('data-ivo-margin') !== 'none';
            if (adjustMargin) rootBodyElement.style.marginTop = `${adjustedHeight}px`;
            const rootBodyElementOffset = parseInt(rootBodyElement.getAttribute('data-ivo-to'), 10) || 0;
            const topPosition = ceilValue((rootBodyElement.getBoundingClientRect().top + rootBodyElementOffset) - centreSkinContainer.offsetHeight);
            const topLimit = parseInt(rootBodyElement.getAttribute('data-ivo-tl'), 10);
            const adjustedTop = (topPosition < topLimit) ? 0 : topPosition;
            centreSkinWrapper.style.top = `${adjustedTop}px`;
            moveSkinContainers();
          }
        }
        centreSkinContainer.style.fontSize = `${PARENT_FONT_SIZE_PX * parseFloat(centreSkinContainer.clientWidth / centreSkinArtboard.viewport.width).toFixed(2)}px`;
      }

      const availableWidth = getAvailableSkinWidth();

      const leftSkinArtboard = selectArtboard(leftSkinArtboards(artboards), [availableWidth, leftSkinContainer.clientHeight]);
      const rightSkinArtboard = selectArtboard(rightSkinArtboards(artboards), [availableWidth, rightSkinContainer.clientHeight]);
      const backgroundArtboard = selectArtboard(backgroundSkinArtboards(artboards), [getWindowDimensions().width + backgrondSkinTollerance, getWindowDimensions().height + backgrondSkinTollerance]);

      if (leftSkinArtboard && rightSkinArtboard) {
        leftSkinContainer.style.fontSize = `${PARENT_FONT_SIZE_PX * parseFloat(leftSkinContainer.clientWidth / leftSkinArtboard.viewport.width).toFixed(2)}px`;
        rightSkinContainer.style.fontSize = `${PARENT_FONT_SIZE_PX * parseFloat(rightSkinContainer.clientWidth / rightSkinArtboard.viewport.width).toFixed(2)}px`;
        const selectedLeftSkinArtboard = leftSkinContainer.getAttribute('data-artboard');
        const selectedRightSkinArtboard = rightSkinContainer.getAttribute('data-artboard');

        if ((selectedLeftSkinArtboard !== leftSkinArtboard.name) || (selectedRightSkinArtboard !== rightSkinArtboard.name)) { renderSkins(); }
      } else if (backgroundArtboard) {
        const selectedBackgroundArtboard = backgroundSkinContainer.getAttribute('data-artboard');
        if ((selectedBackgroundArtboard !== backgroundArtboard.name)) { renderSkins(); }
      }
    });
  }, resizeDelay);
};

export const createSkinsContainer = (tagInformation, placementId, rootElementName, rootBodyElement, canAccessIframe, artboards) => {
  try {
    const rootWindow = window.top; // eslint-disable-line no-undef
    const rootDocument = rootWindow.document; // eslint-disable-line no-undef
    const frameContainer = frameElement ? frameElement.parentNode.parentNode : null;

    const rootBodyElementPadding = rootBodyElement ? parseFloat(window.getComputedStyle(rootBodyElement).paddingLeft) : 0;
    const contentWidth = rootBodyElement ? rootBodyElement.getBoundingClientRect().width : frameContainer.clientWidth;
    const windowWidth = rootDocument.documentElement.clientWidth;
    const skinWidth = ((windowWidth - contentWidth) / 2) - (rootBodyElementPadding);

    const embeddedOverride = (frameElement === null) || getFilteredArtboards(artboards, 'centre-skin-top').length > 0;
    const mobileWrap = getFilteredArtboards(artboards, 'centre-skin-mobile-bottom').length > 0;
    const backgroundSkin = backgroundSkinArtboards(artboards).length > 0;
    const mobileSlide = getFilteredArtboards(artboards, 'mobile-slide').length > 0;
    if (embeddedOverride || mobileWrap) rootBodyElement.setAttribute('data-ivo-config', 'body');
    const embeddedCentre = embeddedOverride ? false : (frameElement.clientWidth > 2 && frameElement.clientWidth > 2);
    const skinContiguration = rootBodyElement.getAttribute('data-ivo-config');
    const centreWrapperStyleBody = (skinContiguration === 'body') ? 'absolute' : 'relative';
    const centreWrapperStyle = (skinContiguration === 'mobile-footer') ? 'fixed' : centreWrapperStyleBody;
    const rootBodyElementTopPosition = (skinContiguration === 'mobile-footer') ? 'auto' : parseInt(rootBodyElement.getAttribute('data-ivo-ts'), 10) || 0;
    const rootBodyElementBottomPosition = (skinContiguration === 'mobile-footer') ? '0' : 'auto';
    const rootBodyElementContainerPosition = (skinContiguration === 'mobile-footer') ? 'auto' : '0';
    const skinsDepth = (rootBodyElement.getAttribute('data-ivo-sd') === null) ? 'auto' : rootBodyElement.getAttribute('data-ivo-sd');
    const centreSkinsDepth = (rootBodyElement.getAttribute('data-ivo-sd') === null) ? '50' : rootBodyElement.getAttribute('data-ivo-sd');

    const centreWrapperTopPosition = (skinContiguration === 'embedded') ? 'auto' : rootBodyElementTopPosition;

    const anchorElement = rootBodyElement.getAttribute('data-ivo-anchor') || null;
    const skinRoot = anchorElement ? rootDocument.querySelector(anchorElement) : rootDocument.body;

    if (embeddedCentre && canAccessIframe && !isNestedIframe()) {
      frameElement.parentNode.style.position = 'absolute';
      frameElement.parentNode.style.left = '0';
    }

    const centreWrapperMargin = mobileSlide ? '0' : 'auto';

    const centreSkinWrapper = rootDocument.createElement('div');
    centreSkinWrapper.id = `ivoCentreSkinWrapper-${tagInformation.sessionId}`;
    centreSkinWrapper.className = `ivo-ad skin centre multi root ${tagInformation.element.id}`;
    centreSkinWrapper.style.cssText = `position: ${centreWrapperStyle}; left: 0; right: 0; top: ${centreWrapperTopPosition}px; bottom: ${rootBodyElementBottomPosition}; width: ${contentWidth}px; height: 0px; border: none; margin: ${centreWrapperMargin}; z-index:${centreSkinsDepth}; `;

    const centreSkinMask = document.createElement('div'); // eslint-disable-line no-undef
    centreSkinMask.id = `ivoCentreSkinMask-${tagInformation.sessionId}`;
    centreSkinMask.style.cssText = 'position: absolute; top: 0px; left: 0px; width: 100%; height: 0px; margin: 0px; padding: 0px; overflow: hidden; clip: rect(0px, auto, auto, 0px); clip-path: inset(0px);';

    const centreSkinContainer = document.createElement('div'); // eslint-disable-line no-undef
    centreSkinContainer.id = `ivoCentreSkinContainer-${tagInformation.sessionId}`;
    centreSkinContainer.className = `ivo-ad skin ivo-ad-container ${tagInformation.element.id}`;
    centreSkinContainer.style.cssText = `position: fixed; top: ${rootBodyElementContainerPosition}; left: auto; right:auto; width: ${contentWidth}px; height: 100px; margin: 0px; padding: 0px; bottom: 0px; overflow-x: hidden; overflow-y: hidden;`;

    if (skinContiguration === 'mobile-footer') centreSkinMask.style.clip = 'auto';

    centreSkinMask.appendChild(centreSkinContainer);
    centreSkinWrapper.appendChild(centreSkinMask);

    const centreSkinContainerEmbedded = document.createElement('div'); // eslint-disable-line no-undef
    centreSkinContainerEmbedded.id = `ivoCentreSkinContainer-${tagInformation.sessionId}`;
    centreSkinContainerEmbedded.setAttribute('data-display', 'embedded');
    centreSkinContainerEmbedded.className = `ivo-ad skin centre multi ivo-ad-container ${tagInformation.element.id}`;
    centreSkinContainerEmbedded.style.cssText = 'position: relative; border: none; margin:auto; top: 0; width: 100%; height: 100px; flex-shrink: 0; transform: translateY(0%); z-index: 1; margin-top: 0;';

    let centreSkinGeom;

    if (skinContiguration === 'embedded') {
      frameContainer.append(centreSkinContainerEmbedded);
      centreSkinGeom = rootBodyElement.getBoundingClientRect();
      centreSkinContainer.parentNode.style.transition = 'height 1s';
    } else {
      skinRoot.insertBefore(centreSkinWrapper, skinRoot.firstChild);
      centreSkinGeom = centreSkinWrapper.getBoundingClientRect();
    }

    const leftSkin = rootDocument.createElement('div');
    leftSkin.className = `ivo-ad skin left multi root ${tagInformation.element.id}`;
    leftSkin.id = `ivoLeftSkinContainer-${tagInformation.sessionId}`;
    leftSkin.style.cssText = `position: fixed; border:none; right: ${centreSkinGeom.right}px; top:0; width: ${skinWidth}px; height: 1200px; margin: 0; z-index: ${skinsDepth}; transition: none !important; `;
    leftSkin.setAttribute('data-ivo-artboard-container', '');

    const rightSkin = rootDocument.createElement('div');
    rightSkin.className = `ivo-ad skin right multi root ${tagInformation.element.id}`;
    rightSkin.id = `ivoRightSkinContainer-${tagInformation.sessionId}`;
    rightSkin.style.cssText = `position: fixed; border:none; left: ${centreSkinGeom.right}px; top:0; width: ${skinWidth}px; height: 1200px; margin: 0; z-index: ${skinsDepth}; transition: none !important; `;
    rightSkin.setAttribute('data-ivo-artboard-container', '');

    const centreSkinBottomContainer = rootDocument.createElement('div');
    centreSkinBottomContainer.className = `ivo-ad skin multi root ${tagInformation.element.id}`;
    centreSkinBottomContainer.id = `ivoCentreSkinBottomContainer-${tagInformation.sessionId}`;
    centreSkinBottomContainer.style.cssText = `position: fixed; left: 0; right: 0; bottom: 0; width: ${contentWidth}px; height: 50px; border: none; margin: auto; z-index:${centreSkinsDepth}; `;
    centreSkinBottomContainer.setAttribute('data-ivo-artboard-container', '');

    const backgroundSkinContainer = rootDocument.createElement('div');
    backgroundSkinContainer.className = `ivo-ad skin multi root background ${tagInformation.element.id}`;
    backgroundSkinContainer.id = `ivoBackgroundSkinContainer-${tagInformation.sessionId}`;
    backgroundSkinContainer.style.cssText = 'position: fixed; left: 0; right: 0; top: 0; width: 100vw; height: 100vh; border: none; margin: auto;';
    backgroundSkinContainer.setAttribute('data-ivo-artboard-container', '');

    const backgroundSkinWrapper = rootDocument.createElement('div');
    backgroundSkinWrapper.id = `ivoBackgroundSkinWrapper-${tagInformation.sessionId}`;
    backgroundSkinWrapper.style.cssText = 'position: absolute; left: 50%; right: 0; top: 0; width: 100vw; height: 100vh; transform: translateX(-50%);border: none; margin: auto;';
    backgroundSkinWrapper.setAttribute('data-ivo-artboard-container', '');
    backgroundSkinContainer.appendChild(backgroundSkinWrapper);

    const skinsContainer = rootDocument.createElement('div');
    skinsContainer.className = `ivo-ad skin multi root ${tagInformation.element.id}`;
    skinsContainer.id = rootElementName;
    skinsContainer.style.cssText = `position: absolute; left: 0; top: ${rootBodyElementTopPosition}px; width: 1px; height: 100vh; background: white; z-index: 0;`;
    skinsContainer.setAttribute('data-ivo-artboard-container', '');

    if (skinContiguration === 'body') {
      centreSkinContainer.style.top = `${rootBodyElementTopPosition}px`;
    }

    if (mobileWrap) skinRoot.appendChild(centreSkinBottomContainer);
    if (backgroundSkin) skinRoot.insertBefore(backgroundSkinContainer, skinRoot.firstChild);

    skinRoot.insertBefore(leftSkin, skinRoot.firstChild);
    skinRoot.insertBefore(rightSkin, skinRoot.firstChild);

    leftSkin.style.top = `${rootBodyElementTopPosition}px`;
    rightSkin.style.top = `${rootBodyElementTopPosition}px`;

    rootWindow.addEventListener('scroll', moveSkinContainers);
    rootWindow.addEventListener('resize', maybeRenderSkins);

    return leftSkin;
  } catch (e) {
    console.log('ivo : error rendering skins container');
    console.log(e);
  }
};



// WEBPACK FOOTER //
// ./app/javascript/renderer/utils/skinsContainer.js